(function () {
  'use strict';

  if (window.PGSocialProofV1) return;
  window.PGSocialProofV1 = true;

  var data = window.PGSocialProofDataV1 || {};
  var root = document.querySelector('[data-pg-social-proof-root]');
  if (!root) return;

  var pageType = root.getAttribute('data-page-type') || '';
  var productId = root.getAttribute('data-product-id') || '';
  var cartUrl = root.getAttribute('data-cart-url') || '/cart';
  var shopRoot = root.getAttribute('data-shop-root') || '/';
  var params = new URLSearchParams(window.location.search);
  var demo = params.get('pg_social_demo') || '';
  var sessionWasAlreadyOpen = false;

  try {
    sessionWasAlreadyOpen = sessionStorage.getItem('pg_social_session_started_v1') === '1';
    sessionStorage.setItem('pg_social_session_started_v1', '1');
  } catch (error) {
    sessionWasAlreadyOpen = true;
  }

  function ageDays(iso) {
    var time = Date.parse(iso || '');
    if (!Number.isFinite(time)) return Infinity;
    return Math.max(0, (Date.now() - time) / 86400000);
  }

  function isVisible(element) {
    if (!element) return false;
    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity || 1) > 0.01 && rect.width > 1 && rect.height > 1;
  }

  function interfaceBusy() {
    var selectors = [
      '.cart_content.pg-open',
      '.cart-container.active_link',
      '.klaviyo-form',
      '[role="dialog"]',
      '.fancybox-container',
      '.modal.is-active',
      '.popup.is-active'
    ];
    return selectors.some(function (selector) {
      return Array.prototype.some.call(document.querySelectorAll(selector), isVisible);
    });
  }

  function removeCard(card) {
    if (!card) return;
    card.classList.remove('is-visible');
    window.setTimeout(function () {
      if (card.parentNode) card.parentNode.removeChild(card);
    }, 320);
  }

  function productHref(handle) {
    var base = shopRoot.charAt(shopRoot.length - 1) === '/' ? shopRoot : shopRoot + '/';
    return base + 'products/' + encodeURIComponent(handle);
  }

  function recentPool() {
    return (data.recent || []).filter(function (entry) {
      return entry && entry.handle && entry.label && entry.city && ageDays(entry.orderedAt) <= 30;
    });
  }

  function getRecentIndex(pool) {
    if (!pool.length) return -1;
    var index = 0;
    try {
      var stored = Number(sessionStorage.getItem('pg_social_recent_index_v1'));
      if (Number.isFinite(stored) && stored >= 0) index = stored % pool.length;
      else index = Math.floor(Math.random() * pool.length);
      sessionStorage.setItem('pg_social_recent_index_v1', String((index + 1) % pool.length));
    } catch (error) {
      index = Math.floor(Math.random() * pool.length);
    }
    return index;
  }

  function recentCard(entry) {
    var card = document.createElement('aside');
    card.className = 'pg-social-proof-card' + (pageType === 'product' ? ' pg-social-proof-card--product' : '');
    card.setAttribute('role', 'status');
    card.setAttribute('aria-live', 'polite');

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'pg-social-proof-card__close';
    close.setAttribute('aria-label', 'Dismiss recent commission');
    close.textContent = '×';
    close.addEventListener('click', function () {
      try { sessionStorage.setItem('pg_social_recent_dismissed_v1', '1'); } catch (error) {}
      removeCard(card);
    });

    var link = document.createElement('a');
    link.className = 'pg-social-proof-card__link';
    link.href = productHref(entry.handle);

    var image = document.createElement('img');
    image.className = 'pg-social-proof-card__image';
    image.src = entry.image;
    image.alt = '';
    image.loading = 'lazy';
    image.width = 62;
    image.height = 62;

    var content = document.createElement('span');
    var eyebrow = document.createElement('span');
    eyebrow.className = 'pg-social-proof-card__eyebrow';
    eyebrow.textContent = 'Recently commissioned';

    var title = document.createElement('strong');
    title.className = 'pg-social-proof-card__title';
    title.textContent = entry.label + ' · ' + entry.city;

    var meta = document.createElement('span');
    meta.className = 'pg-social-proof-card__meta';
    meta.textContent = 'Ordered recently';

    content.append(eyebrow, title, meta);
    link.append(image, content);
    card.append(close, link);
    return card;
  }

  function canShowRecent() {
    if (demo === 'recent' || demo === '1') return true;
    if (interfaceBusy()) return false;
    try {
      if (sessionStorage.getItem('pg_social_recent_dismissed_v1') === '1') return false;
      var count = Number(sessionStorage.getItem('pg_social_recent_shown_v1') || 0);
      var max = window.matchMedia('(max-width: 767px)').matches ? 1 : 2;
      return count < max;
    } catch (error) {
      return true;
    }
  }

  function showRecent(attempt) {
    attempt = attempt || 0;
    if (!canShowRecent()) {
      if (attempt < 3 && !demo) window.setTimeout(function () { showRecent(attempt + 1); }, 5000);
      return;
    }

    var pool = recentPool();
    var index = getRecentIndex(pool);
    if (index < 0) return;

    var card = recentCard(pool[index]);
    document.body.appendChild(card);
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { card.classList.add('is-visible'); });
    });

    try {
      var shown = Number(sessionStorage.getItem('pg_social_recent_shown_v1') || 0) + 1;
      sessionStorage.setItem('pg_social_recent_shown_v1', String(shown));
    } catch (error) {}

    window.setTimeout(function () { removeCard(card); }, demo ? 15000 : 5200);
  }

  function popularityWindow() {
    if (!productId) return null;
    var sales = (data.popularitySales || []).filter(function (sale) {
      return String(sale.productId) === String(productId) && ageDays(sale.orderedAt) <= 30;
    });
    if (!sales.length) return null;

    var count14 = sales.reduce(function (sum, sale) {
      return sum + (ageDays(sale.orderedAt) <= 14 ? Number(sale.quantity || 0) : 0);
    }, 0);
    var count30 = sales.reduce(function (sum, sale) {
      return sum + Number(sale.quantity || 0);
    }, 0);
    var minimum = Number(data.minimumPopularityCount || 3);

    if (count14 >= minimum) return { count: count14, period: 'this fortnight' };
    if (count30 >= minimum) return { count: count30, period: 'this month' };
    return null;
  }

  function productForm() {
    return document.querySelector(
      '.product_section .product_form, .product_section form[action*="/cart/add"], main .product_form, main form[action*="/cart/add"], .product_form, form[action*="/cart/add"]'
    );
  }

  function popularityMount() {
    var form = productForm();
    if (!form) return null;
    return form.querySelector('.purchase-details') || form.querySelector('.purchase-details__buttons') || form;
  }

  function renderPopularity() {
    if (pageType !== 'product' || !productId || document.querySelector('[data-pg-product-popularity]')) return;
    var stat = popularityWindow();
    if (!stat) return;

    var copyTemplate = (data.popularityCopy && data.popularityCopy[String(productId)]) || 'Apparently, this one is popular {period}.';
    var line = document.createElement('div');
    line.className = 'pg-product-popularity';
    line.dataset.pgProductPopularity = '';

    var text = document.createElement('span');
    text.append(document.createTextNode(copyTemplate.replace('{period}', stat.period) + ' '));
    var strong = document.createElement('strong');
    strong.textContent = '· ' + stat.count + ' ordered';
    text.append(strong);
    line.append(text);

    var mount = popularityMount();
    if (!mount) return;
    if (mount === productForm()) mount.prepend(line);
    else mount.parentNode.insertBefore(line, mount);
  }

  function getCart() {
    return fetch(cartUrl + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart unavailable');
      return response.json();
    });
  }

  function cartReturnCard() {
    var card = document.createElement('aside');
    card.className = 'pg-cart-return-card' + (pageType === 'product' ? ' pg-cart-return-card--product' : '');
    card.setAttribute('role', 'status');
    card.setAttribute('aria-live', 'polite');

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'pg-cart-return-card__close';
    close.setAttribute('aria-label', 'Dismiss basket reminder');
    close.textContent = '×';
    close.addEventListener('click', function () { removeCard(card); });

    var eyebrow = document.createElement('span');
    eyebrow.className = 'pg-cart-return-card__eyebrow';
    eyebrow.textContent = 'Saved for you';

    var title = document.createElement('h3');
    title.className = 'pg-cart-return-card__title';
    title.textContent = 'Still deciding?';

    var copy = document.createElement('p');
    copy.className = 'pg-cart-return-card__copy';
    copy.textContent = 'Your portrait has been patiently waiting. Complete your order today and enjoy 25% off.';

    var cta = document.createElement('a');
    cta.className = 'pg-cart-return-card__cta';
    cta.href = shopRoot + 'discount/WELCOMEBACK25?redirect=' + encodeURIComponent(cartUrl);
    cta.textContent = 'CLAIM 25% OFF NOW';

    card.append(close, eyebrow, title, copy, cta);
    return card;
  }

  function shouldCheckReturnCart() {
    if (pageType === 'cart' || /\/cart(?:\/|$)/.test(window.location.pathname)) return false;
    if (demo === 'cart') return true;
    if (sessionWasAlreadyOpen) return false;
    try {
      return sessionStorage.getItem('pg_social_cart_reminder_shown_v1') !== '1';
    } catch (error) {
      return false;
    }
  }

  function maybeShowReturnCart() {
    if (!shouldCheckReturnCart()) return Promise.resolve(false);
    return getCart().then(function (cart) {
      if (!cart || Number(cart.item_count || 0) < 1) return false;
      if (interfaceBusy() && demo !== 'cart') return false;

      var card = cartReturnCard();
      document.body.appendChild(card);
      try { sessionStorage.setItem('pg_social_cart_reminder_shown_v1', '1'); } catch (error) {}
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { card.classList.add('is-visible'); });
      });
      window.setTimeout(function () { removeCard(card); }, demo ? 18000 : 8500);
      return true;
    }).catch(function () {
      return false;
    });
  }

  function dismissFloatingCards() {
    document.querySelectorAll('.pg-social-proof-card, .pg-cart-return-card').forEach(removeCard);
  }

  function init() {
    renderPopularity();

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (target && target.closest && target.closest('.mini_cart, .cart-container, [data-minicart-checkout-button], .pg-cart__checkout-btn')) {
        dismissFloatingCards();
      }
    }, true);
    document.addEventListener('cart:refresh', dismissFloatingCards);

    var cartDelay = (demo === 'cart' || demo === 'recent' || demo === '1') ? 500 : 7000;
    window.setTimeout(function () {
      maybeShowReturnCart().then(function (shown) {
        if (shown) return;
        var recentDelay = demo === 'recent' || demo === '1' ? 300 : 1800;
        window.setTimeout(function () { showRecent(0); }, recentDelay);
      });
    }, cartDelay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
